import DoctorAppointmentListBody from "components/ClinicalManagement/DoctorAppointments/DoctorAppointmentListBody";
import Header from "components/Common/Header/Header";
import React, { useEffect } from "react";

const DoctorAppointments = () => {
  useEffect(() => {
    document.title = "Doctor Appointments";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <DoctorAppointmentListBody />
    </main>
  );
};

export default DoctorAppointments;
